import { trigger, transition, style, animate, query, stagger } from '@angular/animations';

export const searchResultAnimations = [
  trigger('listStagger', [
    transition('* => *', [
      query(
        ':enter',
        [
          style({ transform: 'scale(0.8)', opacity: 0 }),
          stagger('80ms', [
            animate('250ms cubic-bezier(0.35, 0, 0.25, 1)', style({ transform: 'scale(1)', opacity: 1 }))
          ])
        ],
        { optional: true }
      )
    ])
  ]),
  trigger('articlesSlide', [
    transition(':enter', [
      style({ transform: 'translateY(20px)', opacity: 0 }),
      animate('400ms 100ms cubic-bezier(0.35, 0, 0.25, 1)', 
        style({ transform: 'translateY(0)', opacity: 1 })
      )
    ])
  ]),
  trigger('remainingFaqsStagger', [
    transition('* => *', [
      query(
        ':enter',
        [
          style({ transform: 'scale(0.8)', opacity: 0 }),
          stagger('80ms', [
            animate('250ms cubic-bezier(0.35, 0, 0.25, 1)', style({ transform: 'scale(1)', opacity: 1 }))
          ])
        ],
        { optional: true }
      )
    ])
  ])
];
